import NavBar from "layout/navbar";
import SideBar from "layout/sidebar";
import ModalsHolder from "layout/discovery/ModalsHolder";
import { AlertsHolder } from "components/Alert";
import React from "react";
import SettingsSideBar from "layout/settings/SettingsSideBar";
import { HashRouter, Navigate, Route, Routes } from "react-router-dom";
import ReadabilityThresholds from "layout/settings/readabilityThresholds/ReadabilityThresholds";
import ReadabilityIgnoreList from "layout/settings/readabilityIgnoreList/ReadabilityIgnoreList";
import DiscoveryIgnoreList from "layout/settings/discoveryIgnoreList/DiscoveryIgnoreList";
import AcronymIgnoreList from "layout/settings/acronymIgnoreList/AcronymIgnoreList";
import ExcelOutput from "layout/settings/excelOutputCustomization/ExcelOutputCustomization";

const SettingsPage = () => (
  <div className="settings_page">
    <NavBar />
    <SideBar />
    <div style={{ height: "100%" }}>
      <ModalsHolder />

      <div data-testid="settings-page" className="settings">
        <HashRouter>
          <SettingsSideBar />
          <div>
            <AlertsHolder />
            <div className="settings_content">
              <Routes>
                <Route path="/" element={<ReadabilityThresholds />} />
                <Route
                  path="/readability"
                  element={<ReadabilityIgnoreList />}
                />
                <Route path="/discovery" element={<DiscoveryIgnoreList />} />
                <Route path="/acronym" element={<AcronymIgnoreList />} />
                <Route path="/excel_output" element={<ExcelOutput />} />
                <Route path="*" element={<Navigate to="/" replace />} />
              </Routes>
            </div>
          </div>
        </HashRouter>
      </div>
    </div>
  </div>
);

export default SettingsPage;
